import { render, staticRenderFns } from "./upgradePopoverTips.vue?vue&type=template&id=393ac508"
import script from "./upgradePopoverTips.vue?vue&type=script&lang=js"
export * from "./upgradePopoverTips.vue?vue&type=script&lang=js"
import style0 from "./upgradePopoverTips.vue?vue&type=style&index=0&id=393ac508&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.5.0_webpack@5.105.4_clean-css@5.3.3_cssnano@5.0.0_postc_e826d77c341d9375f73ff64d8afd261c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports